/* eslint-disable react/jsx-max-depth */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FloatingArrow, FloatingPortal, arrow, autoUpdate, flip, offset, shift, useClick, useFloating, useInteractions } from '@floating-ui/react';
import T from 'prop-types';
import React, { forwardRef, useCallback, useContext, useEffect, useRef } from 'react';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useClickOutside } from '../../hooks/useClickOutside';
import useEventListener from '../../hooks/useEventListener';
import { getMapQueryData } from '../../redux/actions';
import { convertToGeoJson } from '../../utilities/map';
import Icon from '../icon/Icon';
import { PRODUCT_DATA } from '../mapView/constants';
import { MapViewContext } from '../mapView/mapViewContext';
import ShapeMenu from '../shapeMenu/ShapeMenu';
var ARROW_WIDTH = 24;
var ARROW_HEIGHT = 12;
var ShapeMenuModal = /*#__PURE__*/ forwardRef(function(param, ref) {
    var shapeData = param.shapeData, shapeName = param.shapeName, _param_placement = param.placement, placement = _param_placement === void 0 ? 'left' : _param_placement;
    var actions = useContext(MapViewContext).actions;
    var dispatch = useDispatch();
    var dialogRef = useRef(null);
    var arrowRef = useRef(null);
    var _useContext = useContext(MapViewContext), closeShapeMenuModal = _useContext.actions.closeShapeMenuModal;
    useClickOutside(dialogRef, function() {
        return closeShapeMenuModal();
    }, [
        '.click-outside-excluded'
    ]);
    var _useFloating = useFloating({
        placement: placement,
        middleware: [
            flip(),
            offset({
                mainAxis: 26
            }),
            shift({
                padding: 16
            }),
            arrow({
                element: arrowRef
            })
        ],
        whileElementsMounted: autoUpdate
    }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, context = _useFloating.context, update = _useFloating.update;
    var click = useClick(context);
    var getFloatingProps = useInteractions([
        click
    ]).getFloatingProps;
    useEffect(function() {
        if (!ref.current) {
            actions.closeShapeMenuModal();
        }
    }, [
        actions,
        ref
    ]);
    var handleEscapePress = function(event) {
        if (event.key === 'Escape') {
            closeShapeMenuModal();
        }
    };
    useEventListener('keydown', handleEscapePress, document);
    useEventListener('resize', update);
    useEffect(function() {
        if (ref.current && shapeData) {
            refs.setReference(ref.current);
            onProductMenuOpen();
            update();
        }
    }, [
        onProductMenuOpen,
        ref,
        refs,
        shapeData,
        update
    ]);
    var onProductMenuOpen = useCallback(function() {
        if (shapeData) {
            dispatch(getMapQueryData({
                region: convertToGeoJson([
                    {
                        region: shapeData.region
                    }
                ]).features[0].geometry,
                category_names: PRODUCT_DATA.result
            }));
        }
    }, [
        dispatch,
        shapeData
    ]);
    return /*#__PURE__*/ React.createElement(FloatingPortal, null, /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: refs.setFloating,
        style: _object_spread_props(_object_spread({}, floatingStyles), {
            zIndex: 1000
        })
    }, getFloatingProps()), /*#__PURE__*/ React.createElement("div", {
        className: "position-relative",
        style: {
            border: '1px solid #BDBDBD',
            borderRadius: 2
        }
    }, /*#__PURE__*/ React.createElement(FloatingArrow, {
        context: context,
        ref: arrowRef,
        width: ARROW_WIDTH,
        height: ARROW_HEIGHT,
        fill: "#fff",
        stroke: "#BDBDBD",
        strokeWidth: 0.8,
        style: {
            zIndex: 1
        }
    }), /*#__PURE__*/ React.createElement(Modal.Dialog, {
        id: "product-dropdown-menu-container",
        ref: dialogRef
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "align-align-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            fontSize: 16,
            fontWeight: '600'
        }
    }, shapeName)), /*#__PURE__*/ React.createElement(Button, {
        onClick: function(ev) {
            ev.stopPropagation();
            closeShapeMenuModal();
        },
        variant: "light",
        className: "row-action icon-button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "close"
    }))), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement(ShapeMenu, {
        data: shapeData,
        DropdownMenuComponent: Dropdown.Menu,
        show: true,
        className: "product-dropdown",
        closeMenu: closeShapeMenuModal,
        closeDropdownOnSelect: false
    }))))));
});
ShapeMenuModal.propTypes = {
    shapeData: T.object,
    shapeName: T.string,
    placement: T.string
};
ShapeMenuModal.displayName = 'ShapeMenuModal';
export default ShapeMenuModal;
